import {Grid, Typography} from "@mui/material";

export default function WelcomeSettings() {
    return (<>
        <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item sx={{textAlign: "center"}}>
                <Typography variant="h2">Settings Home</Typography>
                <Typography>Select a category to the left</Typography>
            </Grid></Grid></>);
}